module.exports = __webpack_public_path__ + "a276b39dfbadc1f53f976a14aedeedd5.svg";